import {Suspense} from 'react';

import {type DataTypeProvider} from '@devexpress/dx-react-grid';
import Stack from '@mui/material/Stack';

import OptixTableDeleteAction from './components/OptixTableDeleteAction';
import OptixTableEditAction from './components/OptixTableEditAction';
import {OptixTableRowAction} from './components/OptixTableRowAction';
import {useOptixTableActionsProviderContext} from './OptixTableActionsProviderContext';

export default function OptixTableActionsProviderFormatter({
  row,
}: DataTypeProvider.ValueFormatterProps): JSX.Element {
  const {enableEdit, enableDelete, enableRowActions} =
    useOptixTableActionsProviderContext();

  return (
    <Stack direction="row" p={0} spacing={0.5}>
      <Suspense fallback={null}>
        {enableEdit && <OptixTableEditAction row={row} />}
        {enableDelete && <OptixTableDeleteAction row={row} />}
        {enableRowActions && <OptixTableRowAction row={row} />}
      </Suspense>
    </Stack>
  );
}
